import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Container, JumpTarget, slugify, theme } from '@sweetgreen/garnish';

import type { DeliveryOrderDetailInput } from '@order/graphql';

import type { CategoryFragment } from '../../GraphQL/Restaurant.query.generated';
import { MenuCategory, MenuCustomCategory } from './subcomponents';

// ────────────────────────────────────────────────────────────────────────────────

export const MenuCategories = (props: CategoriesProps) => {
  const { categories, restaurantSlug, deliveryDetails } = props;

  return (
    <View style={styles.wrapper} testID="menu.categories.wrapper">
      <Container>
        {categories.map((category) => (
          <MenuCategoryWrapper
            key={category.id}
            categoryId={category.id}
            categoryName={category.name}
          >
            {category.isCustom ? (
              <MenuCustomCategory
                customProducts={category.products}
                restaurantSlug={restaurantSlug}
                deliveryDetails={deliveryDetails}
              />
            ) : (
              <MenuCategory
                category={category}
                restaurantSlug={restaurantSlug}
                deliveryDetails={deliveryDetails}
              />
            )}
          </MenuCategoryWrapper>
        ))}
      </Container>
    </View>
  );
};

// ─── SUBCOMPONENTS ──────────────────────────────────────────────────────────────

const MenuCategoryWrapper: React.FC<MenuCategoryWrapperProps> = (props) => {
  const { categoryId, categoryName, children } = props;
  const testID = slugify(`menupage.${categoryName}-container`);

  return (
    <JumpTarget id={categoryId}>
      <View style={styles.categoryWrapper} testID={testID}>
        {children}
      </View>
    </JumpTarget>
  );
};

// ─── STYLES ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  wrapper: {
    paddingBottom: theme.spacing['10'],
    backgroundColor: theme.colors.KHAKI_3,
  },
  categoryWrapper: {
    paddingTop: 64,
  },
});

// ─── TYPES ──────────────────────────────────────────────────────────────────────

type CategoriesProps = {
  readonly categories: readonly CategoryFragment[];
  readonly restaurantSlug: string;
  readonly deliveryDetails?: DeliveryOrderDetailInput;
};

type MenuCategoryWrapperProps = {
  readonly categoryId: string;
  readonly categoryName: string;
};
